module.exports = __webpack_public_path__ + "static/media/icone-cnh-livre.4cbc3a5f.png";